import { PolicyConfiguration, PolicyLimitConfiguration, POLICY_TYPE, POLICY_LIMIT_TYPE } from "./policy-configuration";

export class TableBookingPolicy extends PolicyConfiguration {
  constructor(identifier, policyLevel) {
    super(identifier, POLICY_TYPE.TableBooking, policyLevel);

    this.limits = [];
  }

  toString() {
    let limitsString = 'No limits';
    if (this.limits && this.limits.length > 0) {
      limitsString = this.limits
        .map(l => Object.assign(new TableBookingPolicyLimit(), l))
        .map(l => l.toString())
        .join(', ');
    }

    return `${this.identifier}: ${POLICY_TYPE.nameof(this.policyType)} (${limitsString})`;
  }

  isValid() {
    let isValid = !!this.identifier && !!this.identifier.trim();
    if (this.limits && this.limits.length > 0) {
      isValid = isValid && this.limits
        .map(l => Object.assign(new TableBookingPolicyLimit(), l))
        .every(l => l.isValid());
    }
    return isValid;
  }

  static fromJSON(json){
    if(!json) return undefined;

    return Object.assign(new TableBookingPolicy(), json);
  }
}

export class TableBookingPolicyLimit extends PolicyLimitConfiguration {
  constructor(limitType, minPercentage, maxPercentage) {
    super('TableBookingPolicyLimitConfiguration', limitType);

    this.minPercentage = Number.parseInt(minPercentage);
    this.maxPercentage = Number.parseInt(maxPercentage);
  }

  static fromJSON(json){
    if(!json) return undefined;

    return Object.assign(new TableBookingPolicyLimit(), json);
  }

  toString() {
    return `${POLICY_LIMIT_TYPE.nameof(this.limitType)}: ${this.minPercentage}%-${this.maxPercentage}%`;
  }

  isValid() {
    const minIsValid =
      this.minPercentage !== undefined &&
      this.minPercentage !== null &&
      this.minPercentage >= 0;

    const maxIsValid =
      this.maxPercentage !== undefined &&
      this.maxPercentage !== null &&
      this.maxPercentage >= 0 &&
      this.maxPercentage >= this.minPercentage;

    return minIsValid && maxIsValid;
  }
}


